import { deliveryIndex, isLocalMessage, isOwnOutgoing } from './localMessage'

interface FeedMessage {
  id: string
  content: string
  timestamp: string
  isFromMe?: boolean
  /** Автор исходящего на общем номере; на личном номере его нет. */
  authorManagerId?: string
  /** 'bot' — ответ AI-ассистента (DEV-1676). */
  authorType?: string
}

/**
 * DEV-2502. Досинхронизация открытого чата (переподключение сокета, возврат во
 * вкладку): свежая первая страница сервера сливается с лентой, а не заменяет её.
 * Серверные сообщения заменяют свои копии по id (статусы, правки), новые встают по
 * времени; догруженная раньше история остаётся. Локальные пузыри (pending-/failed-)
 * тоже остаются — кроме тех, что сервер уже принял: своё новое исходящее с тем же
 * текстом в окне попытки, один к одному (как keepUnsent у Telegram). Своё — личный
 * номер (автора нет) или me на общем: исходящее коллеги или AI-ассистента с тем же
 * текстом не снимает моё «Не отправлено» (DEV-2492, DEV-1676).
 */
export function mergeFreshPage<T extends FeedMessage>(
  current: readonly T[],
  page: readonly T[],
  me?: string,
): T[] {
  const byId = new Map(page.map((m) => [m.id, m]))
  const known = new Set(current.map((m) => m.id))
  const fresh = page.filter((m) => !known.has(m.id))
  const sent = fresh.filter((m) => isOwnOutgoing(m, me))
  const kept = current.flatMap((m) => {
    if (!isLocalMessage(m)) return [byId.get(m.id) ?? m]
    const delivered = deliveryIndex(m, sent)
    if (delivered === -1) return [m]
    sent.splice(delivered, 1)
    return []
  })
  return [...kept, ...fresh].sort((a, b) => Date.parse(a.timestamp) - Date.parse(b.timestamp))
}
